// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_p-0";
export var skeletonCard = "_p-1";